module.exports = __webpack_public_path__ + "static/img/2-1.8b923a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2-1.png
// module id = 2RSr
// module chunks = 1